import React, { Component } from "react";
import { Button } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Grid, Row, Col } from "@vds/grids";
import { Notification } from '@vds/notifications';
import { Input, CheckboxGroup, RadioButtonGroup } from "@vds/inputs";
import NavHeader from '../../Common/NavHeader/NavHeader';
import common, { refreshChatHashTag } from "../../utils/common";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from "./containers/actions";
import "./SaveCart.css";
import { TextLink } from '@vds/buttons';
import Icon from '@vds/icons';
import * as SiteAnalytics from '../../sitecatalyst';
// import * as ChatAnalytics from '../../utils/lpchatMetrics';
import { getChatInfo } from './containers/actions';
import { getRetrieveCartInfo, updatePageLoadType, updateIsCheckoutPageVisited, updateIsSaveCartPageVisited } from '../CustomizeOrder/containers/actions';
import { saveCurrentLocation } from '../../containers/actions';
import SpinnerComponent from '../../Common/Spinner/Spinner';
import { scrollInView } from '../../utils/common';
import { showSpinner } from "../AddressValidationPage/containers/action";
import { isMobile } from 'react-device-detect';
import FloatingCartPrintPDF from '../../Common/FloatingCart/FloatingCartPrintPDF';
import '../../Common/FloatingCart/FloatingCart.css';
import { PRINT_CART, RED_SKY_ENABLED } from '../../containers/constants';
import styled from 'styled-components';
import { MarginSpacerM, MarginTopSpacerL } from '../Checkout/styleTag';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import ChatLink  from '../../Common/ChatLink/ChatLink';
import * as SiteAnalyticsOmni from '../../sitecatalyst/omniDl';
const InfoButton = styled(Button)`
  border: 1px solid white !important;
  color: white !important;
  margin-left:350px;
  margin-top:10px;
  outline: none !important;
  box-shadow: none !important;
  @media screen and (max-width:600px){
    display:none !important;
  }
`;

const InfoNotification = styled(Notification)`
@media screen and (max-width:419px){
  [class^=Title-sc]{
    max-width:100% !important;
  }
}
@media screen and (max-width:600px){
  .off_com_3mon{
    margin:5px 0 0 30px !important;
    line-height:1;
  }
  resize_header_not{
		align-items: flex-start !important;
		flex-wrap: inherit !important;
	  }
  }
`;


const MBGModal = styled(Modal)`
  height: auto;
  width: 500px;
  min-height: unset;
  padding: 20px
  > div:first-child {
    overflow:hidden;
    min-height: unset;
    }
    @media only screen and (max-width: 600px) {
      position: absolute;
      top: 10px;
      right:10px;
      left:9px;
      width: 95vw;
      max-width: 95vw;
      height: 97vh;
      > div:first-child {
          padding:2px;
      }
      h2 { margin-top: 1rem; }
    }
`;

class SaveCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableErrorMessageForInitial: false,
      enableErrorMessageForConfirmEmail: false,
      errorMessageForIntialEmail: "Please enter your valid email address.",
      errorMessageForConfirmEmail: "Email address not matching.",
      intialEmail: props.saveCartEmail || props.businessInfo?.email || props.LQEmail ||  "",
      confirmEmail:  props.saveCartEmail ||  props.businessInfo?.email || props.LQEmail || "",
      reminderMail: true,
      sendOffersInfo: false,
      comments: "",
      radioValue: "",
      showErrorNotification: false,
      isSubmitClicked: false,
      initiateChat: false,
      endInteraction: false,
      viewMBGModal: false,
    };
  }
  saveEmailAddress = (e) => {
    const emailAddress = e.target.value;
    if (e.target.name == "email-address") {
      this.setState({
        intialEmail: emailAddress,
        confirmEmail: '',
      });
    } else {
      this.setState({
        confirmEmail: emailAddress,
      });
    }
  };

  componentWillReceiveProps(props) {
    const { isVOCallInProgress } = props;
    if (!isVOCallInProgress && this.state.isSubmitClicked) {
      this.setState({isSubmitClicked: false});
      this.continueClick();
    }
  }

  onSubmit = () => {
    const { isVOCallInProgress } = this.props;
    if (!isVOCallInProgress) {
      this.continueClick();
    } else {
      this.setState({isSubmitClicked: true});
      this.props.showSpinner(true);
    }
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    // document.getElementsByClassName("global-notification")[0].style.display = "none"; // will revert once the notification issue resolved 
    window.saveCartMounted = true;
    this.props.saveCurrentLocation(window.location.pathname);
    this.setState({ initiateChat: true });
    this.setState({ endInteraction: true });
  }

  componentDidUpdate() {
    if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
      window.newrelic.interaction().end();
      this.setState({ endInteraction: false });
    }
    if (this.state.initiateChat) {
      SiteAnalytics.trackPageInfo('SaveCart');
      this.props.getChatInfo("checkout");
      // For Chat Refresh On URL Change..
      refreshChatHashTag();
      this.setState({ initiateChat: false });
    }
  }
  selectedRadioValue = (e) => {
    let { radioValue } = this.state;
    radioValue = e.target.value;
    this.setState({ radioValue });
  }
  btnHandler = () => {
    if (window.prevUrl && window.prevUrl?.indexOf("/customize-order") > -1) {
      this.props.updatePageLoadType('R');
      this.props.updateIsCheckoutPageVisited('N');
      this.props.updateIsSaveCartPageVisited('Y');
      this.props.getRetrieveCartInfo({ callback: (function() {
        this.props.history.go(-1);
      }).bind(this) });
    }
    else {
      // this.props.history.push("/checkout", { from: "save-cart" })
      this.props.history.go(-1)
    }

  };
  continueClick = () => {
    this.setState({
      enableErrorMessageForConfirmEmail: false, enableErrorMessageForIntialEmail: false
    });
    if (this.state.intialEmail !== "" && common.isValidEmail(this.state.intialEmail?.trim())) {
      if (this.state.intialEmail?.trim()?.toLowerCase() === this.state.confirmEmail?.trim()?.toLowerCase()) {
        const saveCartInfo = {
          Comments: this.state.comments,
          Disclaimer: this.state.sendOffersInfo ? 'Y' : 'N',
          EMail: this.state.confirmEmail,
          RatingSelected: this.state.radioValue,
          SkipReminderMail: this.state.reminderMail ? 'N' : 'Y'
        }
        const history = this.props.history;
        this.props.saveEmailAddress(this.state.confirmEmail)
        this.props.actions.saveCartConfirmation(saveCartInfo, history);
      }
      else {
        this.setState({
          enableErrorMessageForConfirmEmail: true,
          showErrorNotification: true,
        });
        scrollInView(".Email-Input");
      }
      // ChatAnalytics.setPurchaseTracking(this.props.getFloatCartResponse, '');
    } else {
      this.setState({
        enableErrorMessageForIntialEmail: true,
        showErrorNotification: true,
      });
      scrollInView(".Email-Input");
    }
  };

  print = () => {
      const content = document.createElement("div");
      const prtContent1 = document.getElementsByClassName("RsCXl");
      const prtContent2 = document.getElementById("print");
      content.innerHTML = (prtContent1 && prtContent1[0] ? prtContent1[0].innerHTML : '') + (prtContent2?.innerHTML ? prtContent2.innerHTML : '');
      const winPrint = window.open('', 'PRINT');
      // winPrint.setTimeout(function () {
          winPrint.document.write(content.innerHTML);
          winPrint.document.close();
          winPrint.focus();
          winPrint.print();
          winPrint.close();
      // }, 1000);
  }

  modalChangeMBG = (viewMBGModal) => {
    this.setState({ viewMBGModal: viewMBGModal })
  };

  renderMBGModal = () => {
    return (<MBGModal
      ariaLabel=""
      opened={this.state.viewMBGModal}
      onOpenedChange={this.modalChangeMBG}
      disableOutsideClick={true}
    >
    <p className='verizonModal2g'>
      <div style={{padding:'0px 15px'}}>
        <Title size="large">Money Back Guarantee</Title>	
      </div>
      			
      <MarginSpacerM/>
      <ModalBody>Money Back Guarantee (MBG) is available with 2 year contract 
        only and requires cancellation within 30 days of installation;
        excludes subscriptions, per minute usage, labor/material charges
        in excess of standard installation and month-to-month service
        plans, including Fios TV service. Wireless router available for
        $299.99 purchase and $15/mo rental, subject to change. Phone
        equipment purchase required with VoIP, starting at $85.
        Equipment must be returned within 30 days of cancellation.
        Equipment restocking fee may apply if order is cancelled or 
        service is terminated within 30 days. MBG and/or promotional
        offers do not apply to service ordered for temporary, short term 
        or special events.
      </ModalBody>
    </p>
  </MBGModal>)
  }

  render() {
    const { LQPost } = this.props;
    const mbgFlag = LQPost?.HSIStatus === "Y" || LQPost?.SpeedType.includes("VDSL1");
    if(!mbgFlag) {
      SiteAnalyticsOmni.omniTrackOpenView("Not sure if you're ready to order?", "#modal");
    }
    return (
      <div className="save-cart-container">
        {(this.props.toggleLoadingSpinner) ? <SpinnerComponent /> : ""}
        <div className={`sticky-wrapper sticky'`} >
          <NavHeader
            customizeOrder={[]}
            selectedServiceVoice={null}
            // globalscope={LQPost ? LQPost : {}}
            history={this.props.history}
            globalscope={
               (this.props.getPostLqData ? this.props.getPostLqData : this.props.LQPost ? this.props.LQPost : {})
          }
          // globalscope={this.props.pageLoadType === 'R' ? (this.props.ReviewOrderLQPost ? this.props.ReviewOrderLQPost : (this.props.LQPost ? this.props.LQPost : (this.props.ReviewOrderLQPost || {}))) : (this.props.LQPost ? this.props.LQPost : (this.props.ReviewOrderLQPost || {}))}
											
            hideCart
          />
        </div>
        <TextLink
          iconPosition="left"
          onClick={(e) => {
            this.btnHandler();
          }}
          className="back-link-text mtb1"
        >
          <span className="arrow-icon">
            <Icon name="caret-left" size="small" />
          </span>
          <span>Go back</span>
        </TextLink>
        {!mbgFlag && <InfoNotification type="info">
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap',fontSize:'16px',
          fontWeight:'bold',marginTop:'-15px' }} className = {"resize_header_not"}>
            <div className='off_3mon_tool' style={{marginTop: '3px'}}>
              <Icon name='info' size="medium" inverted={true} medium/>
            </div>
            <span style={{marginLeft:'10px',lineHeight:'1'}}>Not sure if you're ready to order?</span>
            <span><InfoButton onClick={() => this.modalChangeMBG(true)} secondary>Review offer details</InfoButton></span>
            </div>
            <div style={{fontSize:'16px',fontWeight:'normal',margin:'-15px 0 0 30px'}} className='off_com_3mon'>
            We offer a 30-day money-back guarantee.
          </div>          
        </InfoNotification>}        
        <Grid>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
              <div className="Page-Title">
              { this.props.getPostLqData?.IsShowLiveChat && this.props.getPostLqData?.IsShowLiveChat === 'Y' &&  <ChatLink style={{ float: "right"}} />}
                <Title size="large" primitive="h1">
                  Save your order
                </Title>
              </div>
              <div>
                <Body size="small" primitive="h2">
                  We will save your cart and send you e-mail reminders with links so you can continue where you left off.
                </Body>
              </div>
              {PRINT_CART === 'true' && <div>
                <Body size="small" primitive="h2">
                  You can also review a 
                  <TextLink onClick={() => this.print()}> printable version of your order.</TextLink>
                </Body>
              </div>}
            </Col>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
            {this.state.showErrorNotification && <Notification type="error" className="error-notification"
                                            onCloseButtonClick={() => { this.setState({ showErrorNotification: false }) }}
                                        >{"Please enter required fields."}</Notification>}
              <div className="email-header">
                {/* <Body size="medium" bold primitive="h1">
                  Enter email address
                </Body> */}
              </div>
              <div className="Email-Input">
                <Input
                  id="emailAddress"
                  label="Enter email address"
                  value={this.state.intialEmail}
                  placeholder=""
                  name="email-address"
                  width="292px"
                  error={this.state.enableErrorMessageForIntialEmail}
                  errorText={this.state.errorMessageForIntialEmail}
                  onChange={this.saveEmailAddress}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
              <div className="Email-Input">
                <Input
                  id="confirmEmailAddress"
                  label="Enter confirm email Address"
                  value={this.state.confirmEmail}
                  placeholder=""
                  name="confirm-email-address"
                  width="292px"
                  error={this.state.enableErrorMessageForConfirmEmail}
                  errorText={this.state.errorMessageForConfirmEmail}
                  onChange={this.saveEmailAddress}
                />
              </div>
            </Col>
          </Row>
          {/* These radio buttons are removed following Story :- PPMFFIIAAA-188
          <Row>
            <div className="checkbox-section">
              <CheckboxGroup
                childWidth={"100%"}
                viewport={"desktop"}
                onChange={(e) => this.setState({ reminderMail: !this.state.reminderMail })}
                data={[
                  {
                    children: "Send me up to three email reminders about my saved order.",
                    width: "200px",
                    selected: this.state.reminderMail,
                  },
                ]}
              />
            </div>
          </Row>
          <Row>
            <CheckboxGroup
              childWidth={"100%"}
              viewport={"desktop"}
              onChange={(e) => this.setState({ sendOffersInfo: !this.state.sendOffersInfo })}
              data={[
                {
                  children: "Send me Verizon marketing information and offers",
                  width: "200px",
                  selected: this.state.sendOffersInfo,
                },
              ]}
            />
          </Row> */}
          <Row>
            <div colSizes={{ desktop: 12 }}>
              <div className="rating">
                <Body size="medium" bold primitive="h1">
                  How was your ordering experience?
                </Body>
              </div>
              <div>
                <RadioButtonGroup
                  onChange={(e) => { this.selectedRadioValue(e) }}
                  data={[
                    {
                      name: "mailtype",
                      children: "Great!",
                      value: "5",
                      ariaLabel: "Great!",
                    },
                    {
                      name: "mailtype",
                      children: "Very good",
                      value: "4",
                      ariaLabel: "Very good",
                    },
                    {
                      name: "mailtype",
                      children: "Satisfactory",
                      value: "3",
                      ariaLabel: "Satisfactory",
                    },
                    {
                      name: "mailtype",
                      children: "Not so good",
                      value: "2",
                      ariaLabel: "Not so good",
                    },
                    {
                      name: "mailtype",
                      children: "Poor",
                      value: "1",
                      ariaLabel: "Poor",
                    },
                  ]}
                />
              </div>
            </div>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
              <div className="Page-Title">
                <Body size="medium" bold primitive="h1">
                  Why are you leaving the ordering flow?
                </Body>
              </div>
              <div>
                <Body size="small" primitive="h2">
                  Your response will be reviewed and used to improve the customer experience when applicable. Thank you.
                </Body>
              </div>
            </Col>
            <div className="response-Input">
            <Body size="small" primitive="h2">
                Write response here. Please do not use this form to request a call back, { !isMobile ? <br/> : <> </> }this is for online feedback only.   
              </Body>
              <Input
                label=""
                value={this.state.comments}
                placeholder=""
                name="email-address"
                width="292px"
                onChange={(e) => this.setState({ comments: e.target.value })}
              />
            </div>
          </Row>
          <Row>
            <div className="Submit-Button">
              <Button onClick={this.onSubmit}>Submit</Button>
            </div>
          </Row>
          <MarginTopSpacerL/>
          <div className="hide-pdf-content">
            <FloatingCartPrintPDF />
          </div>
        </Grid>
        {this.state.viewMBGModal && this.renderMBGModal()}
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { AddressValidationPage, SaveCartPage, CustomizeOrder, CheckoutPage } = state;
  return {
    LQPost: AddressValidationPage?.addressQualificationDetails?.LQPost,
    toggleLoadingSpinner: AddressValidationPage?.toggleLoadingSpinner,
    getPostLqData: CustomizeOrder.getPostLqData,
    pageLoadType: CustomizeOrder.pageLoadType,
    LQEmail: AddressValidationPage?.emailAddress,
    businessInfo: CheckoutPage.contactInfo,
    saveCartEmail: CheckoutPage.saveCartEmail,
    isVOCallInProgress: CheckoutPage.isVOCallInProgress,
    getFloatCartResponse: CustomizeOrder.getFloatCartResponse,
    ReviewOrderLQPost: CustomizeOrder.getPostLqData
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  getChatInfo: (data) => dispatch(getChatInfo(data)),
  getRetrieveCartInfo: (data) => dispatch(getRetrieveCartInfo(data)),
  updatePageLoadType: (data) => dispatch(updatePageLoadType(data)),
  saveCurrentLocation: (data) => dispatch(saveCurrentLocation(data)),
  updateIsCheckoutPageVisited: (data) => dispatch(updateIsCheckoutPageVisited(data)),
  updateIsSaveCartPageVisited: (data) => dispatch(updateIsSaveCartPageVisited(data)),
  showSpinner: (data) => dispatch(showSpinner(data))  
});
SaveCart = connect(mapStateToProps, mapDispatchToProps)(SaveCart);

export default SaveCart;
